import React, { Component } from "react";
import Images from "../Images";
import { AppConfig } from "../../../helpers";
import SlotGame from "./SlotGame";
import { connect } from "react-redux";
import { JackpotLevel } from "../../../helpers/enums";

export class SpecialGame extends Component {
  render() {
    const {
      specialGame,
      history,
      jackpotBalances,
      singleGameWinningMessage,
    } = this.props;
    console.log("jackpotBalancesaaaa", jackpotBalances);
    return (
      <div className="special-game-wrapper">
        {specialGame && specialGame.length > 0 && (
          <SlotGame
            gameId={specialGame[0].gameId}
            history={history}
            src={`${AppConfig.icons}${specialGame[0].platformGameName}/${specialGame[0].platformGameName}_b.webp`}
          />
        )}
        <div className="jackpot-prize">
          {!singleGameWinningMessage ? (
            <>
              {" "}
              {jackpotBalances && jackpotBalances[JackpotLevel.SingleGame] ? (
                <>
                  {" "}
                  <span className="label">
                    {jackpotBalances[JackpotLevel.SingleGame].jackpotName}
                  </span>{" "}
                  <span className="value">
                    LRD {jackpotBalances[JackpotLevel.SingleGame].jackpotAmount}{" "}
                    / USD{" "}
                    {jackpotBalances[JackpotLevel.SingleGame].jackpotUsdValue}
                  </span>{" "}
                </>
              ) : null}{" "}
            </>
          ) : (
            <p className="label" style={{ textAlign: "center" }}>
              {singleGameWinningMessage}
            </p>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (_, initialProps) => (state) => {
  return {
    jackpotBalances: state.jackpot.jackpotBalances,
    singleGameWinningMessage: state.jackpot.singleGameWinningMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialGame);
